import { useState } from 'react'
import { auth } from '@/api/endpoints'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Err } from '@/components/Err'
import { AuthCard } from './Card'

// 비밀번호가 없는 계정(F-34: OAuth 로 들어온 사람)이 셸 대신 보는 화면. OAuth 는 편의이고 비밀번호가 자격이라, 정할 때까지 이 화면만 있다.
// 정하면 `me` 를 다시 읽어 셸로 들어간다. 나가는 길은 로그아웃뿐이다.

export function PasswordGate({ username, onSet, onLogout }: { username: string; onSet: () => void; onLogout: () => void }) {
  const [next, setNext] = useState('')
  const [again, setAgain] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<unknown>(null)
  const same = next.length > 0 && next === again
  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await auth.changePassword('', next)
      setNext('')
      setAgain('')
      onSet()
    } catch (err) {
      setError(err)
      setBusy(false)
    }
  }
  return (
    <AuthCard title="비밀번호 설정" onSubmit={submit}>
      <p className="text-[13px]">{username} 계정을 계속 쓰려면 비밀번호를 정하세요.</p>
      <Input type="password" placeholder="새 비밀번호" autoComplete="new-password" minLength={8} value={next} disabled={busy} onChange={(e) => setNext(e.target.value)} />
      <Input type="password" placeholder="새 비밀번호 확인" autoComplete="new-password" value={again} disabled={busy} onChange={(e) => setAgain(e.target.value)} />
      {again.length > 0 && !same ? <p className="text-[12px] text-danger-ink">비밀번호가 서로 다릅니다.</p> : null}
      <Button type="submit" disabled={busy || next.length < 8 || !same} className="bg-brand hover:bg-brand-hover">{busy ? '저장 중' : '저장'}</Button>
      <Err error={error} />
      <button type="button" onClick={onLogout} className="text-center text-[12px] text-muted-foreground hover:text-foreground hover:underline">로그아웃</button>
    </AuthCard>
  )
}
